module.exports = __webpack_public_path__ + "media/placeholder-images/placeholder_11-0704237a.jpg";